/* Furniture Instore — PDP v5 behaviour.
   Reuses the theme's existing product form (product-form.js) for Add to Basket;
   this file only proxies clicks, syncs the sticky bar and hands the postcode
   over to the existing Delivery Estimator section. */
(function () {
  'use strict';

  /* Both the sticky-header section and main-product enqueue this file, so guard
     against the whole thing initialising twice. */
  if (window.FIPDP && window.FIPDP.booted) return;
  window.FIPDP = window.FIPDP || {};
  window.FIPDP.booted = true;

  var money = function (cents) {
    var fmt = window.FIPDP && window.FIPDP.moneyFormat;
    var value = (cents / 100).toFixed(2);
    if (!fmt) return '£' + value;
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  function mainForm() {
    return document.querySelector('product-info form[data-type="add-to-cart-form"]');
  }

  function mainSubmit() {
    var form = mainForm();
    return form ? form.querySelector('[name="add"]') : null;
  }

  function currentVariantId() {
    var form = mainForm();
    var input = form ? form.querySelector('.product-variant-id, [name="id"]') : null;
    return input ? input.value : null;
  }

  /* The stepper is NOT inside the <form>. It is bound to it by the HTML `form`
     attribute — `form="{{ product_form_id }}"` — which submits with the form while
     leaving the input outside it in the DOM. So form.querySelector('[name=quantity]')
     found nothing and every quantity read came back as 1: nothing scaled with the
     stepper, and Buy Now posted a quantity of one however many the customer had asked
     for. Looked up by that same association, with the v5 row preferred because a
     template can carry the theme's own stepper as well. */
  function quantityInput() {
    var form = mainForm();
    var scoped = document.querySelector('.fi-actions [name="quantity"]');
    if (scoped) return scoped;
    if (form) {
      var inside = form.querySelector('[name="quantity"]');
      if (inside) return inside;
      if (form.id) {
        var bound = document.querySelector('[name="quantity"][form="' + form.id + '"]');
        if (bound) return bound;
      }
    }
    return document.querySelector('product-info [name="quantity"]');
  }

  function currentQuantity() {
    var input = quantityInput();
    var qty = input ? parseInt(input.value, 10) : 1;
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  /* Each ticked add-on with the quantity it should go in at. An add-on marked
     data-fi-addon-scales is bought once per sofa — two sofas need two deliveries —
     and everything else is once per order however many sofas there are: the care
     plan covers the whole basket, and removal is sized by its own dropdown. */
  function selectedAddons() {
    var qty = currentQuantity();
    return Array.prototype.slice
      .call(document.querySelectorAll('[data-fi-addon]:checked'))
      .filter(function (input) {
        return input.value;
      })
      .map(function (input) {
        return {
          id: input.value,
          quantity: input.hasAttribute('data-fi-addon-scales') ? qty : 1
        };
      });
  }

  function cartDrawer() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /* Add-ons ticked at the moment Add to Basket was pressed, waiting for the sofa itself to
     land before they are added. */
  var pendingAddons = [];
  var drawerChangeVersion = 0;

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('cart-drawer cart-remove-button')) drawerChangeVersion += 1;
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('cart-drawer-items')) drawerChangeVersion += 1;
  }, true);

  function addPendingAddons() {
    var ids = pendingAddons;
    pendingAddons = [];
    if (!ids.length) return;

    var drawerVersion = drawerChangeVersion;
    var drawer = cartDrawer();
    var payload = {
      items: ids.map(function (addon) {
        return { id: Number(addon.id), quantity: addon.quantity };
      })
    };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      payload.sections = drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
      payload.sections_url = window.location.pathname;
    }

    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (!state || state.status || drawerVersion !== drawerChangeVersion) return;
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
      })
      .catch(function () {
        /* The sofa is already in the basket; a failed add-on must not disturb that. */
      });
  }

  /* The theme's form announces every add it makes. That is the signal that the sofa is in,
     and therefore that the add-ons can safely follow. */
  (function watchForMainAdd() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(watchForMainAdd, 300);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'product-form' && pendingAddons.length) addPendingAddons();
    });
  })();

  /* ================================================================
     Ask before adding with nothing ticked
     ================================================================

     The list is built from the real rows when the dialog opens rather than rendered a
     second time in Liquid. One set of checkboxes carries the variant ids, one set of
     prices has to be kept right, and a row the care-plan tier has just hidden cannot be
     offered here by mistake. */
  var promptDeclined = false;
  var promptAction = null;

  function promptDialog() {
    return document.querySelector('[data-fi-addon-prompt]');
  }

  /* Only rows a customer could actually tick: the care-plan row is hidden and disabled
     when the basket is out of its range, and an out-of-stock add-on is disabled too. */
  function offerableAddons() {
    return Array.prototype.slice.call(document.querySelectorAll('.fi-addon')).filter(function (row) {
      if (row.hidden) return false;
      var box = row.querySelector('[data-fi-addon]');
      return !!box && !box.disabled;
    });
  }

  function shouldPromptForAddons() {
    var dialog = promptDialog();
    if (!dialog) return false;
    if (promptDeclined && dialog.hasAttribute('data-fi-prompt-once')) return false;
    /* They have already chosen. Standing between them and the basket now would be rude. */
    if (selectedAddons().length) return false;
    return offerableAddons().length > 0;
  }

  function refreshPromptTotal() {
    var dialog = promptDialog();
    if (!dialog) return;
    var slot = dialog.querySelector('[data-fi-prompt-total]');
    if (!slot) return;
    var qty = currentQuantity();
    var extra = Array.prototype.slice
      .call(dialog.querySelectorAll('[data-fi-prompt-for]:checked'))
      .reduce(function (sum, tick) {
        var price = parseInt(tick.dataset.price, 10) || 0;
        return sum + (tick.dataset.fiScales === 'true' ? price * qty : price);
      }, 0);
    slot.textContent = extra > 0 ? ' ' + money(extra) : '';
  }

  function buildPromptList() {
    var dialog = promptDialog();
    var list = dialog ? dialog.querySelector('[data-fi-prompt-list]') : null;
    if (!list) return;

    list.textContent = '';

    offerableAddons().forEach(function (row) {
      var box = row.querySelector('[data-fi-addon]');
      var name = row.querySelector('.fi-addon__name');
      var price = row.querySelector('[data-fi-addon-price]');
      var variant = row.querySelector('[data-fi-addon-variant]');

      var item = document.createElement('label');
      item.className = 'fi-prompt__item';

      var tick = document.createElement('input');
      tick.type = 'checkbox';
      tick.className = 'fi-prompt__check';
      /* Points back at the row it mirrors, which is how the choice is applied. */
      tick.dataset.fiPromptFor = box.id;
      tick.dataset.price = box.dataset.price || '0';
      tick.dataset.fiScales = box.hasAttribute('data-fi-addon-scales') ? 'true' : 'false';

      var label = document.createElement('span');
      label.className = 'fi-prompt__name';
      label.textContent = name ? name.textContent.trim() : '';

      /* Says which configuration is about to be added, for an add-on that has one. The
         dropdown itself stays on the page: changing it here would mean keeping two
         pickers in step for the sake of a choice almost nobody makes at this moment. */
      if (variant && variant.options[variant.selectedIndex]) {
        var chosen = document.createElement('span');
        chosen.className = 'fi-prompt__variant';
        chosen.textContent = variant.options[variant.selectedIndex].textContent.split('—')[0].trim();
        label.appendChild(chosen);
      }

      var cost = document.createElement('span');
      cost.className = 'fi-prompt__price';
      /* The line total, not the unit price: at a quantity of five the delivery really
         is five deliveries, and quoting one of them here would understate the add. */
      if (tick.dataset.fiScales === 'true' && currentQuantity() > 1) {
        cost.textContent = money((parseInt(tick.dataset.price, 10) || 0) * currentQuantity());
      } else {
        cost.textContent = price ? price.textContent.trim() : '';
      }

      item.appendChild(tick);
      item.appendChild(label);
      item.appendChild(cost);
      list.appendChild(item);
    });

    refreshPromptTotal();
  }

  function openAddonPrompt(action) {
    var dialog = promptDialog();
    if (!dialog) {
      action();
      return;
    }
    promptAction = action;
    buildPromptList();
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }
  }

  function closeAddonPrompt() {
    var dialog = promptDialog();
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  /* Whatever was ticked in the dialog is applied to the real rows, and the change is
     announced so the running total and the button price follow it. */
  function applyPromptChoices() {
    var dialog = promptDialog();
    if (!dialog) return;
    Array.prototype.slice.call(dialog.querySelectorAll('[data-fi-prompt-for]')).forEach(function (tick) {
      var real = document.getElementById(tick.dataset.fiPromptFor);
      if (!real || real.checked === tick.checked) return;
      real.checked = tick.checked;
      real.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('[data-fi-prompt-for]')) refreshPromptTotal();
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var go = event.target.closest('[data-fi-prompt-confirm], [data-fi-prompt-skip]');
    if (go) {
      if (go.hasAttribute('data-fi-prompt-confirm')) applyPromptChoices();
      /* Both buttons count as having been asked: confirming with nothing ticked is an
         answer too, and re-asking it on the next press would be a loop. */
      promptDeclined = true;
      /* Read before closing — closing is what clears it. */
      var action = promptAction;
      promptAction = null;
      closeAddonPrompt();
      if (action) action();
      return;
    }

    /* Cancel: the close button, or the backdrop, which lands on the dialog itself.
       Escape is the browser's own and needs nothing here. Nothing is added — they
       pressed a button and are put back where they were. */
    if (event.target.closest('[data-fi-prompt-close]') || event.target.matches('.fi-prompt')) {
      promptAction = null;
      closeAddonPrompt();
    }
  });

  /* ---- Add to Basket ----

     The sofa goes in through the theme's own product form — the same path the page's own
     Add to Basket button uses, which is known to render and open the drawer correctly.
     This only forwards the click and remembers which add-ons were ticked.

     Order matters. The previous version added the add-ons first and the sofa second, so a
     sofa that failed to land left the customer holding a Sofa Removal on its own, and the
     drawer's markup then disagreed with the real cart. Sofa first means a failed add-on
     costs an extra, never the item they actually came for.

     Nothing here redirects: the sticky button must behave exactly like the one further
     down the page. */
  function proxyAdd(event) {
    var button = mainSubmit();
    if (!button || button.disabled) return;
    if (event) event.preventDefault();

    if (shouldPromptForAddons()) {
      openAddonPrompt(function () {
        proxyAdd();
      });
      return;
    }

    pendingAddons = selectedAddons();
    button.click();
  }

  /* ---- The buy column's own Add to Basket ----

     Only the sticky bar's button ever went through proxyAdd, so pendingAddons was left
     empty whenever the customer used the button in the buy column — the one most of them
     use — and every add-on they had ticked was silently dropped. This records them for the
     same post-add pass, and asks first when nothing has been ticked.

     Capture phase, because product-form.js handles the form's submit and the point is to
     get in before it. The prompt's own re-click lands here too, and finds nothing to ask
     about by then. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[name="add"]');
    if (!button || button.disabled) return;
    if (!button.closest('product-info form[data-type="add-to-cart-form"]')) return;

    if (shouldPromptForAddons()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openAddonPrompt(function () {
        button.click();
      });
      return;
    }

    pendingAddons = selectedAddons();
  }, true);

  /* ---- Buy Now: add everything, then straight to checkout ----

     fi-cart-drawer-sync.js watches the cart and opens the drawer after any add that the
     theme's own form did not make, which includes this one. That is right for every other
     route into the cart and wrong for this one: the customer is already being sent to the
     checkout, so the drawer only flashes over a page that is leaving — and its pending
     open survived in the back/forward cache, so returning from the checkout re-opened it
     unasked. The flag below tells the sync to stand down for this add. It is never
     cleared: from here the page only navigates away. */
  function proxyBuyNow(event) {
    if (event) event.preventDefault();

    if (shouldPromptForAddons()) {
      openAddonPrompt(function () {
        proxyBuyNow();
      });
      return;
    }

    var id = currentVariantId();
    if (!id) return;
    var items = [{ id: Number(id), quantity: currentQuantity() }];
    selectedAddons().forEach(function (addon) {
      items.push({ id: Number(addon.id), quantity: addon.quantity });
    });
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    window.FIPDP.skipDrawerOpen = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function () {
        window.location.href = root + 'checkout';
      })
      .catch(function () {
        window.location.href = root + 'cart';
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-fi-proxy]');
    if (!trigger) return;
    if (trigger.dataset.fiProxy === 'add') proxyAdd(event);
    if (trigger.dataset.fiProxy === 'buy-now') proxyBuyNow(event);
  });

  /* ---- What the ticked add-ons come to ---- */
  function addonExtra() {
    var qty = currentQuantity();
    return Array.prototype.slice
      .call(document.querySelectorAll('[data-fi-addon]:checked'))
      .reduce(function (sum, input) {
        var price = parseInt(input.dataset.price, 10) || 0;
        return sum + (input.hasAttribute('data-fi-addon-scales') ? price * qty : price);
      }, 0);
  }

  /* ---- What a scaling add-on costs on the row itself ----
     Two sofas mean two deliveries, so the delivery row has to say £99.98 and not the
     £49.99 one of them costs — the row is where the customer checks the price before
     ticking, and a unit price there disagrees with every total further down the page.

     Only the text is rewritten. data-price stays the unit price, because it is the
     figure every other sum is built from: multiply it in place and the next pass would
     multiply the result again. */
  function refreshAddonRowPrices() {
    var qty = currentQuantity();
    Array.prototype.slice
      .call(document.querySelectorAll('[data-fi-addon][data-fi-addon-scales]'))
      .forEach(function (input) {
        var unit = parseInt(input.dataset.price, 10);
        if (isNaN(unit) || !input.id) return;
        Array.prototype.forEach.call(
          document.querySelectorAll('[data-fi-addon-price="' + input.id + '"]'),
          function (node) {
            node.textContent = money(unit * qty);
          }
        );
      });
  }

  /* The price in the buttons is the sofa plus whatever is ticked, so it answers the only
     question the customer is asking of it. syncBarPrice owns every price slot, so this
     just asks it to run again. */
  function refreshAddonPricing() {
    refreshAddonRowPrices();
    syncBarPrice();
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-fi-addon]')) refreshAddonPricing();

    /* The quantity stepper moves the sofa total, and with it any add-on bought once
       per sofa. Both 'input' and 'change' are watched below: typing into the field
       fires the first, and the +/- buttons set .value in script and fire the second. */
    if (event.target.matches('[name="quantity"]')) refreshAddonPricing();
  });

  /* 'change' on a number field only fires on blur, so without this the total sits on
     the old figure while the customer is still looking at the new one. */
  document.addEventListener('input', function (event) {
    if (event.target.matches('[name="quantity"]')) refreshAddonPricing();
  });

  /* fi-care-plan-tier.js rewrites the care-plan row's price when the basket moves it to
     another tier, and the buttons have to follow. Published rather than copied, so there
     is one implementation of what they say. */
  window.FIPDP.refreshAddonPricing = refreshAddonPricing;

  /* ---- Add-on variant picker ----
     The tickbox carries the variant id that goes into the basket, so changing the
     dropdown has to rewrite it — otherwise the sofa's removal would be added at
     the armchair's price. Both the row price and the dialog price share the same
     data attribute, so one query updates whichever is on screen. */
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches || !select.matches('[data-fi-addon-variant]')) return;

    var uid = select.getAttribute('data-fi-addon-variant');
    var check = document.getElementById(uid);
    var option = select.options[select.selectedIndex];
    if (!check || !option) return;

    check.value = option.value;
    check.dataset.price = option.dataset.price || '';

    Array.prototype.forEach.call(document.querySelectorAll('[data-fi-addon-price="' + uid + '"]'), function (node) {
      node.textContent = money(parseInt(option.dataset.price, 10) || 0);
    });

    /* Re-run unconditionally: the line above has just written the unit price onto the
       row, and a scaling add-on has to be put back to its line total even when it is
       not ticked. Nothing is double-counted — the totals only ever read ticked rows. */
    refreshAddonPricing();
  });

  /* ---- Add-on description dialog ---- */
  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-fi-addon-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-fi-addon-open'));
      if (dialog) {
        event.preventDefault();
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', 'open');
        }
      }
      return;
    }

    var closer = event.target.closest && event.target.closest('[data-fi-addon-close]');
    if (closer) {
      var open = closer.closest('dialog');
      if (open) {
        if (typeof open.close === 'function') {
          open.close();
        } else {
          open.removeAttribute('open');
        }
      }
      return;
    }

    /* Clicking the backdrop lands on the dialog itself, never on its contents. */
    if (event.target.matches && event.target.matches('.fi-addon-dialog')) {
      if (typeof event.target.close === 'function') event.target.close();
    }
  });

  /* ---- Read more inside the dialog ----
     The short version is plain text and the full one keeps the description's own
     markup, so the bullet list survives being expanded. */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-fi-readmore-toggle]');
    if (!toggle) return;

    var scope = toggle.closest('.fi-addon-dialog__text') || toggle.parentElement;
    var short = scope.querySelector('[data-fi-readmore-short]');
    var full = scope.querySelector('[data-fi-readmore-full]');
    if (!short || !full) return;

    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    short.hidden = !expanded;
    full.hidden = expanded;
    toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    toggle.textContent = expanded
      ? toggle.dataset.more || 'Read more'
      : toggle.dataset.less || 'Read less';
  });

  /* ---- Sticky bar: reflect the selected variant's price ---- */
  var variantPrices = null;

  function loadVariantPrices() {
    if (variantPrices) return variantPrices;
    var node = document.querySelector('[data-fi-variant-prices]');
    try {
      variantPrices = node ? JSON.parse(node.textContent) : [];
    } catch (e) {
      variantPrices = [];
    }
    return variantPrices;
  }

  function syncBarPrice() {
    var id = Number(currentVariantId());
    var match = loadVariantPrices().filter(function (v) {
      return v.id === id;
    })[0];
    if (!match) return;

    /* The Add to Basket and Buy Now buttons carry the price too, so they follow
       the picker rather than keeping whatever the first render put there — and they
       carry the quantity and the ticked add-ons with it, because that is the figure
       the customer is agreeing to when they press the button. */
    var qty = currentQuantity();
    var extras = addonExtra();
    var withExtras = match.price * qty + extras;
    Array.prototype.slice.call(document.querySelectorAll('[data-fi-btn-price]')).forEach(function (slot) {
      slot.textContent = money(withExtras);
    });

    /* The sticky bar carries the same figure as the buttons, so a customer who has
       scrolled past the add-ons is not quoted one price at the top of the screen and
       charged another at the bottom of it.

       The struck-through price goes while extras are ticked. It is the compare-at for
       the sofa on its own, so once the figure beside it includes an add-on the two are
       no longer a pair — leaving it there would advertise a saving nobody is getting.
       With nothing ticked the pair is intact and both are shown, exactly as before. */
    var bar = document.querySelector('[data-fi-bar-price]');
    if (!bar) return;

    /* The compare-at is multiplied rather than dropped when the only thing that
       changed is the quantity — two sofas really were two-for-that-price, so the pair
       still holds. Extras are the case that breaks it: they have no compare-at of
       their own, so adding them to one half would advertise a saving nobody gets. */
    var html = '<span class="fi-bar__now">' + money(withExtras) + '</span>';
    if (!extras && match.compare > match.price) {
      html += '<s class="fi-bar__was">' + money(match.compare * qty) + '</s>';
    }
    bar.innerHTML = html;

    Array.prototype.slice.call(document.querySelectorAll('.fi-bar [data-fi-proxy], [data-fi-proxy="buy-now"]')).forEach(function (button) {
      button.disabled = !match.available;
    });
  }

  /* Sections in a JSON template render as #shopify-section-template--<id>__<key>,
     and that numeric id changes per theme — so a tab anchor may be either a real
     element id or just the section key. Resolve both. */
  function resolveTarget(hash) {
    var raw = String(hash || '').replace(/^#/, '');
    if (!raw) return null;
    return (
      document.getElementById(raw) ||
      document.querySelector('[id$="__' + raw + '"]') ||
      document.querySelector('[id$="-' + raw + '"]')
    );
  }

  /* A section can nominate a better landing spot for the times its own layout
     has moved that content down the page: Details + Specification is two
     columns side by side, but stacks below 990px, and stacked it puts the whole
     of Product Details between the section top and the dimensions — so arriving
     at the section top lands on the wrong heading.

     Stacked or not is read off the layout rather than a breakpoint in here, by
     asking whether the marked block still shares a top edge with the block
     before it.

     Shared by everything that scrolls to a section. It used to live inside
     initTabs, so the Measurements tab landed correctly on a phone while the
     "Full specs" link, going the other route, stopped at the top of the section
     with the whole Product Details column still to scroll past. */
  function landingSpot(target) {
    if (!target || !target.querySelector) return target;

    var spot = target.querySelector('[data-fi-landing]');
    if (!spot) return target;

    var peer = spot.previousElementSibling;
    if (!peer) return spot;

    var sideBySide = Math.abs(peer.getBoundingClientRect().top - spot.getBoundingClientRect().top) < 4;
    return sideBySide ? target : spot;
  }

  /* ---- One scroll listener for the whole file ----
     The pinned bar and the tab spy both have to run on scroll, and both need the
     header stack measured. Two independent rAF-throttled handlers meant two style
     resolutions per frame while scrolling — getComputedStyle below is the most
     expensive thing either of them does. Registered in order, so the pin settles
     before the spy reads the bar's position in the same frame. */
  var scrollWork = [];
  var scrollTicking = false;

  function runScrollWork() {
    scrollTicking = false;
    for (var i = 0; i < scrollWork.length; i += 1) scrollWork[i]();
  }

  function onSharedScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(runScrollWork);
  }

  function watchScroll(fn) {
    scrollWork.push(fn);
    if (scrollWork.length === 1) {
      window.addEventListener('scroll', onSharedScroll, { passive: true });
      window.addEventListener('resize', onSharedScroll, { passive: true });
    }
    fn();
  }

  /* Bottom edge of everything parked at the top of the viewport.
     This theme stacks several: the countdown bar, the sticky header, and the
     PDP's own tab bar. An element with top: auto is sticky in name only and
     scrolls away, and one whose rect has not reached its own top offset yet is
     still travelling.

     `predict` asks where each one will sit once the page has scrolled — its own
     top offset plus its height — rather than where it sits right now. Scrolling
     to a section has to clear the bar it will be under after the scroll, not the
     nothing it is under at the top of the page. */
  function stuckHeaderBottom(predict) {
    var bottom = 0;
    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section-group-header-group'), function (node) {
      var styles = getComputedStyle(node);
      if (styles.position !== 'sticky' && styles.position !== 'fixed') return;

      var stickyTop = parseFloat(styles.top);
      if (isNaN(stickyTop)) return;

      var rect = node.getBoundingClientRect();
      if (predict) {
        bottom = Math.max(bottom, stickyTop + rect.height);
        return;
      }
      if (rect.bottom <= 0) return;
      if (rect.top <= stickyTop + 1) bottom = Math.max(bottom, rect.bottom);
    });
    return Math.round(bottom);
  }

  /* How far down the viewport a scroll target has to land to be clear of the
     header stack and the tab bar. Measured fresh on every use: the stack's
     height changes as things stick and unstick on the way down, and the bar is
     only pinned once the page has left the top. */
  function scrollClearance() {
    var bar = document.querySelector('.fi-bar');
    if (!bar) return stuckHeaderBottom(true) + 16;

    /* Already pinned — its own bottom edge is the honest answer. */
    if (bar.classList.contains('fi-bar--pinned')) {
      return Math.round(bar.getBoundingClientRect().bottom) + 16;
    }

    var barTop = parseInt(bar.getAttribute('data-pin-offset'), 10) || 0;
    return stuckHeaderBottom(true) + barTop + bar.offsetHeight + 16;
  }

  /* Non-zero while a tab click's scroll is still travelling, so the scroll spy
     leaves the clicked tab lit instead of flickering through every section the
     page passes on the way there. */
  var autoScrolling = 0;

  function scrollToTarget(target) {
    var aim = function () {
      return target.getBoundingClientRect().top + window.pageYOffset - scrollClearance();
    };

    autoScrolling += 1;
    window.scrollTo({ top: aim(), behavior: 'smooth' });

    /* Lazy images, app embeds and the Trustpilot iframes above the target finish
       loading while the smooth scroll is still travelling, which pushes the
       target down and lands the page past it — that is how a click on Reviews
       ended up in the recommendations below. Re-aim a couple of times once the
       scroll has settled, and stand down the moment the visitor scrolls
       themselves so we never fight them for control. */
    var cancelled = false;
    var stop = function () {
      /* Called both by the visitor taking over and by the realign chain finishing,
         so it has to be safe to call twice — autoScrolling must come back down
         exactly once. */
      if (cancelled) return;
      cancelled = true;
      autoScrolling = Math.max(0, autoScrolling - 1);
      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchmove', stop);
      window.removeEventListener('keydown', stop);
    };
    window.addEventListener('wheel', stop, { passive: true });
    /* touchmove, not touchstart. On a phone the whole interaction is touches:
       the tap that got here, and a thumb coming back down on a page that is
       still travelling. Neither means the visitor wants to steer — only a drag
       does — and cancelling on touchstart stood the re-aim down almost every
       time, which is why this landed short of the section on mobile and not on
       a desktop. */
    window.addEventListener('touchmove', stop, { passive: true });
    window.addEventListener('keydown', stop);

    /* Above the target sit the gallery, the Trustpilot iframe and the hotspot
       images. On a phone connection those settle well after the smooth scroll
       has finished and push the target down, so the re-aim has to outlast them:
       it keeps going until the target has held still twice running, and gives
       up after about three seconds rather than after one. */
    var tries = 0;
    var settled = 0;
    var realign = function () {
      if (cancelled) return;
      tries += 1;

      if (Math.abs(target.getBoundingClientRect().top - scrollClearance()) > 4) {
        settled = 0;
        window.scrollTo({ top: aim(), behavior: 'auto' });
      } else {
        settled += 1;
      }

      if (settled >= 2 || tries >= 10) {
        stop();
        return;
      }
      setTimeout(realign, 250);
    };
    setTimeout(realign, 400);
  }

  /* ---- Tabs: smooth scroll + active state ---- */
  function initTabs() {
    var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-fi-tab]'));
    if (!tabs.length) return;

    /* A tab may name a row in the Collapsible content section, matched on the
       summary's text so the customiser only needs the heading — no block ids to
       keep in step. */
    function findAccordion(heading) {
      var wanted = String(heading || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      if (!wanted) return null;
      var rows = Array.prototype.slice.call(document.querySelectorAll('.collapsible-content details'));
      for (var i = 0; i < rows.length; i += 1) {
        var summary = rows[i].querySelector('summary');
        if (!summary) continue;
        if (summary.textContent.replace(/\s+/g, ' ').trim().toLowerCase() === wanted) return rows[i];
      }
      return null;
    }

    /* Where a tab names an accordion row, that row is the destination — landing on
       the row itself is what "go to Delivery & Returns" means, whereas the section
       named in the anchor is only the neighbourhood it lives in. The anchor stays
       as the fallback for tabs that point at a plain section. */
    function tabTarget(tab) {
      return findAccordion(tab.getAttribute('data-fi-open-accordion')) || resolveTarget(tab.getAttribute('href'));
    }

    var sections = tabs
      .map(function (tab) {
        var el = tabTarget(tab);
        if (!el) {
          tab.hidden = true;
          return null;
        }
        return { tab: tab, el: el };
      })
      .filter(Boolean);

    function markActive(tab) {
      sections.forEach(function (pair) {
        pair.tab.setAttribute('aria-current', pair.tab === tab ? 'true' : 'false');
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        var target = tabTarget(tab);
        if (!target) return;
        event.preventDefault();
        /* Opened before scrolling. The panel expands downwards, so it cannot move
           the summary we are aiming at — and scrollToTarget re-aims anyway. */
        if (target.tagName === 'DETAILS') target.open = true;
        /* Marked straight away rather than waiting for the spy below: the smooth
           scroll takes a few hundred milliseconds, and a tab that stays unlit
           until it arrives reads as a click that did not register. */
        markActive(tab);
        scrollToTarget(landingSpot(target));
      });
    });

    if (!sections.length) return;

    /* ---- Which tab is current ----
       This was an IntersectionObserver watching a band 20–30% down the viewport.
       That band is a fixed slice of the screen and the sticky stack covers the top
       of it, so after a click on Delivery & Returns the row landed *below* the
       band, no entry ever fired, and the bar kept whatever page load had set —
       Overview. Comparing each target against the same clearance line the tabs
       scroll to has no blind spot: the current section is simply the last one that
       has passed under the bar, which is exactly where a click leaves it.

       Sorted by document position rather than by the order the tabs are listed in,
       since "last one past the line" is only meaningful in document order. */
    sections.sort(function (a, b) {
      var where = a.el.compareDocumentPosition(b.el);
      if (where & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
      if (where & Node.DOCUMENT_POSITION_PRECEDING) return 1;
      return 0;
    });

    function spy() {
      /* The click already lit the right tab; leave it until the travel is over or
         the visitor scrolls for themselves. */
      if (autoScrolling > 0) return;
      /* A few pixels of slack: the scroll aims the target at the clearance line,
         and sub-pixel rounding can leave it a hair below. */
      var line = scrollClearance() + 8;
      var current = sections[0];
      sections.forEach(function (pair) {
        if (pair.el.getBoundingClientRect().top <= line) current = pair;
      });
      markActive(current.tab);
    }

    watchScroll(spy);
  }

  /* ---- Postcode: hand off to the existing Delivery Estimator section ---- */
  function initPostcode() {
    var form = document.querySelector('[data-fi-postcode]');
    if (!form) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var value = form.querySelector('input').value.trim();
      var estimator = document.querySelector('form[data-de="form"]');
      if (!estimator) return;
      var input = estimator.querySelector('[data-de="input"]');
      if (input) {
        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      estimator.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (value) {
        if (typeof estimator.requestSubmit === 'function') {
          estimator.requestSubmit();
        } else {
          estimator.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      }
    });
  }

  /* ---- Dimension pills: one tab per piece of a set (3+2, 2+1, …) ----

     Delegated from the document rather than bound per group, because
     product-info.js replaces the whole buy column on a variant change and any
     listener attached to the old markup would go with it. */
  function showUnit(group, index) {
    Array.prototype.slice.call(group.querySelectorAll('[data-fi-unit-tab]')).forEach(function (tab) {
      var on = tab.getAttribute('data-fi-unit-tab') === index;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    Array.prototype.slice.call(group.querySelectorAll('[data-fi-unit-panel]')).forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-fi-unit-panel') !== index;
    });
  }

  function initUnitTabs() {
    document.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-fi-unit-tab]');
      if (!tab) return;
      var group = tab.closest('[data-fi-unit-group]');
      if (!group) return;
      showUnit(group, tab.getAttribute('data-fi-unit-tab'));
    });

    /* Arrow keys move along the tablist, which is what a tablist is expected to
       do — without it the hidden tabs are unreachable, since only the selected
       one is in the tab order. */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      var tab = event.target.closest('[data-fi-unit-tab]');
      if (!tab) return;
      var group = tab.closest('[data-fi-unit-group]');
      if (!group) return;

      var tabs = Array.prototype.slice.call(group.querySelectorAll('[data-fi-unit-tab]'));
      var next = tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1);
      if (next < 0) next = tabs.length - 1;
      if (next >= tabs.length) next = 0;

      event.preventDefault();
      showUnit(group, tabs[next].getAttribute('data-fi-unit-tab'));
      tabs[next].focus();
    });
  }

  /* ---- "Full specs" / dimensions anchors ---- */
  function initAnchors() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-fi-scroll-to]');
      if (!trigger) return;
      var target = resolveTarget(trigger.dataset.fiScrollTo);
      if (!target) return;
      event.preventDefault();
      /* Same landing spot the sticky tabs use, so "Full specs" and the
         Measurements tab arrive at the same place. */
      scrollToTarget(landingSpot(target));
    });
  }

  /* ---- Countdown on the promo banner ----
     A repeating daily clock: it counts down to the end of the current day and
     rolls straight into the next one at midnight, so the offer reads as ending
     today, every day, with no date to keep updating. Hours / minutes / seconds
     only — a 24-hour cycle has no days to show. */
  var countdownTimer = null;

  function initCountdown() {
    /* Clear any interval a previous call left running. The variant-change
       observer re-runs several inits, and a second interval here would double the
       tick rate and leak the first one. */
    if (countdownTimer) {
      clearInterval(countdownTimer);
      countdownTimer = null;
    }

    var el = document.querySelector('[data-fi-countdown]');
    if (!el) return;

    /* ---- The same deadline the announcement bar is counting to ----
       This used to run to the viewer's own local midnight, while the bar at the top
       of the page runs to the end of the sale window in the shop's timezone. On a
       screen in London the two agreed by coincidence; anywhere else they did not,
       and the page showed two different countdowns to the same sale — 13 hours at
       the top and 9 in the buy column.

       The bar's element carries its schedule in data attributes, so the deadline is
       read from there rather than restated here. Nothing to keep in step: change the
       bar's hours in the customiser and this follows.

       toLocaleString in the shop's timezone gives a Date whose local-clock fields
       read as that timezone's wall clock. Both "now" and the window end are built
       that way, so subtracting one from the other gives the true remaining time —
       the shared offset cancels. This is the bar's own technique, on purpose. */
    var bar = document.querySelector('.countdown-announcement[data-timezone]');

    function shopNow(tz) {
      if (!tz) return new Date();
      try {
        return new Date(new Date().toLocaleString('en-US', { timeZone: tz }));
      } catch (e) {
        return new Date();
      }
    }

    function clampHour(value, fallback) {
      var n = parseInt(value, 10);
      if (!isFinite(n)) return fallback;
      return Math.min(24, Math.max(0, n));
    }

    /* Built from a Date rather than by adding 86_400_000, so the target survives the
       two DST changeover days, when the day is 23 or 25 hours long and arithmetic on
       a fixed day length lands an hour out. Recomputed on every roll-over, so nothing
       is cached across days. */
    function nextDeadline() {
      var tz = bar ? bar.getAttribute('data-timezone') : '';
      var now = shopNow(tz);

      if (bar && bar.getAttribute('data-daily-mode') !== 'false') {
        var startHour = clampHour(bar.getAttribute('data-daily-start-hour'), 1);
        var endHour = clampHour(bar.getAttribute('data-daily-end-hour'), 24);

        var end = new Date(now);
        if (endHour === 24) {
          end.setDate(end.getDate() + 1);
          end.setHours(0, 0, 0, 0);
        } else {
          end.setHours(endHour, 0, 0, 0);
          if (endHour <= startHour) end.setDate(end.getDate() + 1);
        }
        if (now >= end) end.setDate(end.getDate() + 1);
        return { end: end.getTime(), tz: tz };
      }

      /* No bar on the page, or it is running to a fixed date: fall back to the end of
         today in the shop's timezone where one is known, and the viewer's otherwise. */
      var midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      return { end: midnight.getTime(), tz: tz };
    }

    var target = nextDeadline();
    var end = target.end;

    var cells = {
      hours: el.querySelector('[data-unit="hours"]'),
      mins: el.querySelector('[data-unit="mins"]'),
      secs: el.querySelector('[data-unit="secs"]')
    };

    var pad = function (n) {
      return String(n).padStart(2, '0');
    };

    /* ---- On when the bar is on ----
       The bar is the sale's switch: turned off in the customiser it does not render,
       and outside its daily window or past its end date its own script hides it. This
       clock is counting to that same sale, so it follows — otherwise switching the
       sale off left a countdown ticking away in the buy column against nothing.

       A customer closing the bar is the one exception. That is them tidying their own
       screen, not the sale ending, so the offer stays where it is. The bar's script
       marks that case with dismissedByUser and every other reason it hides is left
       unmarked, which is exactly the distinction needed here. */
    function saleIsOn() {
      if (!bar) return false;

      /* Both scripts are deferred and neither is guaranteed to run first. Until the
         bar's own script has mounted it, the bar may already be hidden — by the
         pre-paint dismissal check — without dismissedByUser having been set yet, and
         reading it now would hide this clock for a second and then bring it back.
         countdownInit is the flag that script sets once it has decided. */
      if (bar.dataset.countdownInit !== 'true') return true;

      if (bar.dataset.dismissedByUser === 'true') return true;
      return !bar.classList.contains('is-hidden');
    }

    var tick = function () {
      var on = saleIsOn();
      if (el.hidden === on) el.hidden = !on;
      if (!on) return;

      /* Measured against the clock every tick, not decremented from the last one.
         Background tabs throttle setInterval to once a minute or less, so a
         self-decrementing counter would fall behind and stay behind; this is
         correct the instant the tab is focused again, however long it slept. */
      var left = end - shopNow(target.tz).getTime();

      /* Hit zero — retarget and carry on in the same tick, so it never sits on
         00:00:00. Also covers a tab that slept through midnight, or several. */
      if (left <= 0) {
        target = nextDeadline();
        end = target.end;
        left = end - shopNow(target.tz).getTime();
      }

      /* Hours run 0–24 rather than 0–23: at the instant of the roll-over the
         remainder is exactly 86400 seconds, and taking it modulo a day would show
         00:00:00 instead of a full day. */
      var total = Math.floor(left / 1000);
      if (cells.hours) cells.hours.textContent = pad(Math.floor(total / 3600));
      if (cells.mins) cells.mins.textContent = pad(Math.floor((total % 3600) / 60));
      if (cells.secs) cells.secs.textContent = pad(total % 60);
    };

    tick();
    /* Seconds are shown, so this has to run every second. */
    countdownTimer = setInterval(tick, 1000);

    /* Released on navigation away so the interval does not outlive the page in
       the back/forward cache. */
    window.addEventListener(
      'pagehide',
      function () {
        if (countdownTimer) {
          clearInterval(countdownTimer);
          countdownTimer = null;
        }
      },
      { once: true }
    );
  }

  /* ---- Trustpilot: refresh the score and review count from Trustpilot ----
     Reads the same public endpoint Trustpilot's own widgets read, so no API key
     is involved and nothing secret sits in the theme. The Liquid-rendered values
     stay put if the request fails, so the line never ends up blank. */
  function paintStars(wrap, score) {
    var stars = wrap.querySelectorAll('.fi-rating__star');
    var whole = Math.floor(score);
    var partFill = Math.round((score - whole) * 100);
    Array.prototype.forEach.call(stars, function (star, i) {
      var position = i + 1;
      star.classList.remove('fi-rating__star--partial', 'fi-rating__star--empty');
      star.style.removeProperty('--fi-tp-fill');
      if (position <= whole) return;
      if (position === whole + 1 && partFill > 0) {
        star.classList.add('fi-rating__star--partial');
        star.style.setProperty('--fi-tp-fill', partFill + '%');
      } else {
        star.classList.add('fi-rating__star--empty');
      }
    });
    wrap.setAttribute('aria-label', score + ' out of 5');
  }

  function initTrustpilot() {
    var el = document.querySelector('[data-fi-trustpilot]');
    if (!el || typeof fetch !== 'function') return;

    var unit = el.getAttribute('data-businessunit-id');
    var template = el.getAttribute('data-template-id');
    if (!unit || !template) return;

    var url =
      'https://widget.trustpilot.com/trustbox-data/' +
      encodeURIComponent(template) +
      '?businessUnitId=' +
      encodeURIComponent(unit) +
      '&locale=' +
      encodeURIComponent(el.getAttribute('data-locale') || 'en-GB');

    fetch(url, { mode: 'cors', credentials: 'omit' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var business = data && (data.businessUnit || data.businessEntity);
        if (!business) return;

        var total = business.numberOfReviews && business.numberOfReviews.total;
        if (total) {
          var slot = el.querySelector('[data-fi-tp-count]');
          if (slot) {
            var pattern = el.getAttribute('data-count-template') || '[count] Trustpilot reviews';
            slot.textContent = pattern.replace('[count]', Number(total).toLocaleString('en-GB'));
          }
        }

        var score = Number(business.trustScore);
        if (score > 0) {
          var scoreSlot = el.querySelector('[data-fi-tp-score]');
          /* Trustpilot publishes the score to one decimal — match that so 4.8
             does not render as 4.800000000000001. */
          if (scoreSlot) scoreSlot.textContent = score.toFixed(1);
          var stars = el.querySelector('[data-fi-tp-stars]');
          if (stars) paintStars(stars, score);
        }

        var profile = data.links && data.links.profileUrl;
        if (profile) el.setAttribute('href', profile);
      })
      .catch(function () {
        /* Offline, blocked, or endpoint changed — the rendered values stand. */
      });
  }

  /* ---- "See N more combinations" — collapses the existing variant picker ---- */
  var CARET =
    '<svg viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function legendValue(fieldset) {
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    var slot = fieldset.querySelector('.fi-legend__value');
    if (slot) slot.textContent = checked ? checked.value : '';
  }

  /* ---- Configuration grid (sibling products): collapse the overflow ---- */
  function initConfigCollapse() {
    Array.prototype.slice.call(document.querySelectorAll('[data-fi-config]:not([data-fi-enhanced])')).forEach(function (grid) {
      grid.setAttribute('data-fi-enhanced', 'true');
      var items = Array.prototype.slice.call(grid.querySelectorAll('.fi-config__item'));
      var visible = parseInt(grid.dataset.visible, 10) || 6;

      /* Never hide the product being viewed — pull it into the visible run. */
      var currentIndex = items.findIndex(function (item) {
        return item.classList.contains('fi-config__item--current');
      });
      if (currentIndex >= visible) {
        var current = items.splice(currentIndex, 1)[0];
        items.unshift(current);
        grid.insertBefore(current, grid.firstChild);
      }

      var hidden = items.slice(visible);
      if (!hidden.length) return;

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'fi-options__toggle';
      var setState = function (open) {
        hidden.forEach(function (item) {
          item.hidden = !open;
        });
        var text = open
          ? grid.dataset.less || 'See fewer combinations'
          : (grid.dataset.more || 'See [count] more combinations').replace('[count]', hidden.length);
        toggle.innerHTML = '<span>' + text + '</span>' + CARET;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      toggle.addEventListener('click', function () {
        setState(toggle.getAttribute('aria-expanded') !== 'true');
      });
      setState(false);
      grid.appendChild(toggle);
    });
  }

  function enhanceVariants() {
    var host = document.querySelector('[data-fi-collapse-options]');
    var fieldsets = Array.prototype.slice.call(
      document.querySelectorAll('.fi-pdp-v5 .product-form__input--pill:not([data-fi-enhanced])')
    );

    fieldsets.forEach(function (fieldset) {
      fieldset.setAttribute('data-fi-enhanced', 'true');

      var legend = fieldset.querySelector('legend');
      if (legend && !legend.querySelector('.fi-legend__value')) {
        var slot = document.createElement('span');
        slot.className = 'fi-legend__value';
        legend.appendChild(slot);
      }

      /* The theme emits input+label pairs straight into the fieldset — wrap them
         so they can be laid out as a grid. */
      var wrap = document.createElement('div');
      wrap.className = 'fi-options';
      Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]')).forEach(function (input) {
        var label = fieldset.querySelector('label[for="' + input.id + '"]');
        wrap.appendChild(input);
        if (label) wrap.appendChild(label);
      });
      fieldset.appendChild(wrap);

      var labels = Array.prototype.slice.call(wrap.querySelectorAll('label'));

      /* "TOP" style badge on a nominated option value */
      if (host && host.dataset.badgeValue && host.dataset.badgeText) {
        var wanted = host.dataset.badgeValue.trim().toLowerCase();
        labels.forEach(function (label) {
          var input = wrap.querySelector('input[id="' + label.getAttribute('for') + '"]');
          if (!input || input.value.trim().toLowerCase() !== wanted) return;
          var badge = document.createElement('span');
          badge.className = 'fi-option__badge';
          badge.textContent = host.dataset.badgeText;
          label.appendChild(badge);
        });
      }

      /* Collapse the overflow behind a toggle */
      var visible = host ? parseInt(host.dataset.visible, 10) || 6 : 0;
      var hidden = visible ? labels.slice(visible) : [];
      if (hidden.length) {
        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'fi-options__toggle';
        var setState = function (open) {
          hidden.forEach(function (label) {
            label.hidden = !open;
            var input = wrap.querySelector('input[id="' + label.getAttribute('for') + '"]');
            if (input) input.hidden = !open;
          });
          var text = open
            ? host.dataset.less || 'See fewer combinations'
            : (host.dataset.more || 'See [count] more combinations').replace('[count]', hidden.length);
          toggle.innerHTML = '<span>' + text + '</span>' + CARET;
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        toggle.addEventListener('click', function () {
          setState(toggle.getAttribute('aria-expanded') !== 'true');
        });
        setState(false);
        wrap.appendChild(toggle);
      }

      fieldset.addEventListener('change', function () {
        legendValue(fieldset);
      });
      legendValue(fieldset);
    });
  }

  /* ---- Put the theme's quantity stepper and Add to Basket on one row ---- */
  /* ---- Keep app-injected upsell widgets visible, but out of the actions row ----
     SellEasy is configured to inject above the add-to-cart button, so its widget
     lands inside .fi-actions and breaks the quantity + button row. Rather than
     hiding it, move it to just above the row so it keeps its own markup and handlers.

     The widget's block is currently disabled on every product template, so this
     normally finds nothing and returns early. It stays as a safety net for whenever
     the block is switched back on. */
  var UPSELL_SELECTOR = '[class*="lb-widget"], .lb-upsell-widget, [class*="selleasy"]';

  function relocateUpsellWidgets() {
    var row = document.querySelector('.fi-actions');
    if (!row || !row.parentElement) return;

    var found;
    try {
      found = row.querySelectorAll(UPSELL_SELECTOR);
    } catch (e) {
      return;
    }

    Array.prototype.slice.call(found).forEach(function (node) {
      if (node.dataset.fiRelocated) return;
      /* Only handle the outermost match, never a node inside one already handled. */
      if (node.parentElement && node.parentElement.closest('[data-fi-relocated]')) return;
      node.dataset.fiRelocated = 'true';

      /* Default: move it above the row so the quantity stepper stays beside Add
         to Basket. If an app needs its widget to remain inside the <form> (for
         hidden inputs), switch the block to "Stack the row" instead. */
      if (row.dataset.widgetLayout === 'stack' && node.closest('form')) {
        row.classList.add('fi-actions--stacked');
      } else {
        row.parentElement.insertBefore(node, row);
      }
    });
  }

  function watchForUpsellWidgets() {
    var row = document.querySelector('.fi-actions');
    if (!row || !('MutationObserver' in window)) return;
    relocateUpsellWidgets();

    /* One observer per row, never one per call. product-info.js replaces the whole
       buy column on every variant change, so this does have to run again then — the
       old row is detached and its observer is dead — but the flag stops a row that
       is still on the page collecting another observer each time. Without it the
       reapply below stacked a fresh observer on the same node on every mutation,
       and every one of them was notified by every subsequent mutation. */
    if (row.dataset.fiUpsellWatched) return;
    row.dataset.fiUpsellWatched = 'true';

    /* The widget arrives asynchronously from the app, so keep watching the row. */
    new MutationObserver(function () {
      relocateUpsellWidgets();
    }).observe(row, { childList: true, subtree: true });
  }

  /* ---- Publish the sticky bar's height so the sticky gallery clears it ---- */
  function measureBar() {
    var bar = document.querySelector('.fi-bar');
    var height = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--fi-bar-height', height + 'px');
  }

  function watchBarHeight() {
    measureBar();
    window.addEventListener('resize', measureBar);
    if ('ResizeObserver' in window) {
      var bar = document.querySelector('.fi-bar');
      if (bar) new ResizeObserver(measureBar).observe(bar);
    }
  }

  /* ---- Pin the bar to the top of the viewport ----
     position: fixed rather than sticky: the bar's parent is only as tall as the
     bar, so sticky had nothing to travel through. The sentinel sits where the
     bar normally is; once it scrolls past, the bar is fixed and the section
     keeps the bar's height so the page does not jump. */
  function initBarPin() {
    var bar = document.querySelector('.fi-bar');
    var sentinel = document.querySelector('.fi-bar__sentinel');
    if (!bar || !sentinel) return;

    var section = bar.parentElement;
    var pinned = false;

    /* Sit below whatever is actually parked at the top right now — measured, not
       predicted, because the bar has to travel with the stack as it sticks and
       unsticks rather than jump to its final position early. */
    function pinOffset() {
      return (parseInt(bar.getAttribute('data-pin-offset'), 10) || 0) + stuckHeaderBottom(false);
    }

    /* A plain scroll handler rather than IntersectionObserver: the offset changes
       as things above stick and unstick, and rootMargin cannot follow that. */
    function update() {
      var offset = pinOffset();
      var shouldPin = sentinel.getBoundingClientRect().top <= offset;

      if (shouldPin !== pinned) {
        pinned = shouldPin;
        if (pinned) {
          /* Measure before fixing — once fixed the bar is out of flow. */
          section.style.paddingBottom = bar.offsetHeight + 'px';
          bar.classList.add('fi-bar--pinned');
        } else {
          bar.classList.remove('fi-bar--pinned');
          bar.style.top = '';
          section.style.paddingBottom = '';
        }
        measureBar();
      }

      if (pinned) bar.style.top = offset + 'px';
    }

    watchScroll(update);
  }

  function init() {
    watchBarHeight();
    initBarPin();
    watchForUpsellWidgets();
    enhanceVariants();
    initConfigCollapse();
    initTabs();
    initPostcode();
    initUnitTabs();
    initAnchors();
    initCountdown();
    initTrustpilot();
    /* Rows as well as the bar: a page can arrive with the stepper already above one —
       back navigation restores form state — and the rows would then open on the unit
       price while every total below them said something else. */
    refreshAddonPricing();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ---- product-info.js re-renders the buy column on variant change — re-apply ----

     Every pass used to attach another MutationObserver to .fi-actions (see
     watchForUpsellWidgets), so the count grew one-for-one with the number of times
     this ran — and each of those observers was then notified by every subsequent
     mutation in that row. Nothing ever released them. On a page left open through a
     few variant changes, some app writes and a cart update, that is the repeated
     freezing: the work per mutation keeps climbing.

     Two changes here. Only one pass per frame, so a re-render's burst of mutation
     records costs one enhance instead of one per record. And the observer stands
     down while the pass runs: enhanceVariants and initConfigCollapse restructure
     the very subtree being watched, which fed a second, pointless pass straight
     back in. */
  if ('MutationObserver' in window) {
    var container = document.querySelector('.product__info-container');
    if (container) {
      var infoObserver = null;
      var reapplyPending = false;
      var WATCH = { subtree: true, childList: true };

      var reapply = function () {
        reapplyPending = false;
        if (infoObserver) infoObserver.disconnect();
        syncBarPrice();
        watchForUpsellWidgets();
        enhanceVariants();
        initConfigCollapse();
        /* The re-render brought a freshly-tiered care-plan row with it, priced by Liquid off
           the basket as it was when the section was fetched. This puts it back in step with
           the basket as it is now — the same pass, deliberately, rather than a second
           observer on this node. */
        if (typeof window.FIPDP.refreshCarePlanPreview === 'function') {
          window.FIPDP.refreshCarePlanPreview();
        }
        /* Re-armed after the writes, so nothing done above is heard back. Anything
           the theme changed in the meantime is already in the DOM and has already
           been handled by this pass. */
        if (infoObserver) infoObserver.observe(container, WATCH);
      };

      infoObserver = new MutationObserver(function () {
        if (reapplyPending) return;
        reapplyPending = true;
        window.requestAnimationFrame(reapply);
      });
      infoObserver.observe(container, WATCH);
    }
  }
})();
